module.exports = __webpack_public_path__ + "static/media/icon-character__john-lennon.3320a94b.svg";